import type { SdkPlatform } from './getPlatform.types';

/**
 * Returns the platform the SDK is running on.
 *
 * This is the web implementation — the React Native bundler resolves
 * `getPlatform.native.ts` instead when building for React Native, which
 * returns `'react-native'`.
 * @notInstrumented
 */
export const getPlatform = (): SdkPlatform => 'web';
